<script lang="ts">
  import type { Guide } from "../../types";
  import Sprite from "../sprite.svelte";
  import { guideChecklistPath } from "../../support/links";
  import { read } from "../../data/persistence";
  import { createEventDispatcher } from "svelte";
  import Locale from "../locale.svelte";

  export let guide: Guide;

  let readVisited = read(["guides", "visited"], {});

  $: title = guide.indexTitle;
  $: visited = $readVisited;
  $: spots = guide.spots;

  const dispatch = createEventDispatcher();

  function close() {
    dispatch("close");
  }
</script>

<div class="Container">
  {#if title}
    <h1 class="Title">{title}</h1>
  {/if}

  {#if spots.length > 0}
    <ul>
      {#each spots as spot (spot.id)}
        <li>
          <a href={guideChecklistPath(guide, { id: spot.id })} on:click={close}>
            {spot.title}

            {#if spot.isCompletable && visited[spot.id]}
              <Sprite icon="icon-guide-complete-small" size={44} />
            {:else}
              <Sprite icon="icon-chevron-right" />
            {/if}
          </a>
        </li>
      {/each}
    </ul>
  {/if}

  <footer>
    <button class="Action" on:click={close}>
      <Sprite icon="icon-close" />

      <Locale label="guides.closeMenu" />
    </button>
  </footer>
</div>

<style>
  .Container {
    background: var(--theme-bg-elevation-1);
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    flex: 1 0;
    font-size: 16px;
    line-height: 1.4em;
    text-align: left;
    width: 100%;
  }

  .Title {
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-top: 24px;
    padding-left: max(env(safe-area-inset-right), 24px);
    padding-right: max(env(safe-area-inset-left), 24px);
  }

  ul {
    flex: 1 1;
    overflow: auto;
    font-size: 14px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    list-style: none;
    margin-block: 24px;
    margin-left: max(env(safe-area-inset-right), 24px);
    margin-right: max(env(safe-area-inset-left), 24px);
    padding: 0;
  }

  li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    margin: 0;
    padding: 0;
  }

  a {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 64px;
    padding: 16px 8px;
    text-decoration: none;
  }

  footer {
    --padding: 15px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-block: var(--padding);
    padding-left: max(env(safe-area-inset-right), var(--padding));
    padding-right: max(env(safe-area-inset-left), var(--padding));
    display: flex;
    justify-content: flex-end;
  }

  .Action {
    align-items: center;
    flex: 0 0;
    font-size: 14px;
    background: white;
    border-radius: 24px;
    color: inherit;
    border: 1px solid var(--color-tooling);
    display: flex;
    justify-content: center;
    grid-gap: 12px;
    padding: 12px 16px;
    font-size: 14px;
    text-transform: none;
    letter-spacing: 0;
    white-space: nowrap;
  }
</style>
